interface Role {
  label: string;
  value: string;
}

export const roles: Role[] = [
  { label: 'Dispatch', value: 'dispatch' },
  { label: 'Equipment Control', value: 'equipment_control' },
  { label: 'Customer Service', value: 'customer_service' },
  { label: 'Accounting', value: 'accounting' },
  { label: 'Operations Manager', value: 'operations_manager' },
  { label: 'Owner or President', value: 'owner' },
  { label: 'Owner Operator', value: 'owner_operator' },
  { label: 'Other', value: 'other' },
];
